<template>
    <div id="asnImportScanningFile">
        <a-modal
                title="File Upload"
                :visible="importScanningFileVis"
                @cancel="() => (cancel())">

            <template slot="footer">
                <a-row type="flex" justify="center" >
                    <a-col>
                        <a-button class="fonterButton" type="primary" size="small" @click="update">Update</a-button>
                    </a-col>
                    <a-col>
                        <a-button class="fonterButton" type="primary" size="small" @click="cancel">Cancel</a-button>
                    </a-col>
                </a-row>
            </template>

            <a-form :form="fileUploadForm">
                <a-row type="flex" class="buttonLine">
                    <a-col>
                        <!-- :remove="handleRemove"  -->
                        <a-upload 
                                :loading="uploading"
                                :multiple="true"
                                :showUploadList="false"
                                :file-list="fileList" 
                                :before-upload="uploadFile"
                                accept=".txt"
                                >
                            <a-button class="button" size="small" @click="clearFileList">Upload</a-button> 
                        </a-upload>
                    </a-col>
                    <a-col>
                        <a-button class="button" size="small" @click="uploadFileDel">Del</a-button>  
                    </a-col>
                </a-row>
                <hr class="divider"> 
                 <template >
                    <div >
                        <!-- <div style="margin-bottom: 16px">
                        <span style="margin-left: 8px">
                            <template v-if="hasSelected">
                            {{ `Selected ${selectedRowKeys.length} items` }}
                            </template>
                        </span>
                        </div> -->
                        <a-table
                            class="table"
                            :row-selection="{ selectedRowKeys: uploadFileFormKeys, onChange: onSelectChange }"
                            :columns="UploadFIleFormColumns"
                            :dataSource="uploadFileFormList"
                            size="small"
                            :pagination="nopagination"
                            :locale="tabelText"
                            :loading="tableLoadingSub"
                            :scroll="{ y: 300 }"
                        />
                    </div>
                </template>
            </a-form> 
        </a-modal>

    </div>
</template>

<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    export default{
        data(){
            return{
                importScanningFileVis: false,
                fileUploadForm:  this.$form.createForm(this), // add project generic from
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },

                // 表格用数据
                // 分页
                pageSizeOptions: ['5', '10', '20', '30'],
                pagingTotal: 0, // 总数
                pagingSize: 10, // 条数
                currentVal: 1, // 页数,
                tabelText: {
                    emptyText: "Please Upload File"
                },
                tableLoadingSub: false, 
                UploadFIleFormColumns: [
                    {
                        title: "File Name",
                        dataIndex: "fileName",
                        scopedSlots: { customRender: "fileName" }
                    }
                ],
                nopagination: false,
                //列名字
                SubSlotsArray: ["fileName"],
                // 表格
                // 实际文件列表
                fileList: [],
                // 表格的数据
                uploadFileFormList: [],
                // 表格被选择的Keys
                uploadFileFormKeys: [], 
                // 表格被选中的数据
                selectedRows: [],
                // 上传
                uploading: false,
                asnHeaderUid: '',
                typeUid: null,
                pageType: null,
            }
        },
        created() {
            this.init();
        },
        methods:{
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            show(uid) {
                this.importScanningFileVis = true;
                this.asnHeaderUid = uid;
                this.init();
            },
            init() {
            },
            // 选中数据项
            onSelectChange(selectedRowKeys, selectedRows) {
                this.uploadFileFormKeys = selectedRowKeys;
                this.selectedRows = selectedRows;
            },
            update() {
                let uploadFileList = this.fileList.filter(item => this.selectedRows.some(itemRows => itemRows.fileName === item.name));
                if (uploadFileList.length > 0) {
                    let overSizeFile = [];
                    let formData = new FormData();
                    formData.append('orderNo', this.asnHeaderUid);
                    uploadFileList.forEach(file => {
                        if(file.size > 2097152) {
                            overSizeFile.push(file.name);
                        } else {
                            formData.append('files', file);
                        }
                    });
                    if (overSizeFile.length > 0) {
                        let errorMsg = this.$t('publicLang.UploadFileOverSize');
                        overSizeFile.forEach(now => {
                            errorMsg += '\n' + now;
                        })
                        this.$customMessage.warning(errorMsg, 3)
                    } else {
                        this.uploading = true;
                        // Ajax Upload Message To Backend
                        ajax.post(api.ASNIMPORTSCANNINGFILE, formData).then(res => {
                            if (res.code == 200) {
                                this.$message.success(res.msg)
                            } else {
                                var content = '<div>';
                                content += res.msg.replaceAll("\n", "<br>").replaceAll(" ", "&nbsp;");
                                content += '<br>';
                                this.$confirm({
                                    title: <div style="color:black; font-size: 25px;">Result</div>,
                                    content: (h) => {return h('div', {domProps: {innerHTML: content},}, []);},
                                    width: '520px',
                                });
                            }
                            this.$parent.init();
                            this.cancel();
                        })
                    }
                } else {
                   
                    this.$customMessage.warning(this.$t("publicLang.PleaseSltAtleast"));
                }
            },
            cancel() {
                this.uploadFileFormList = [];
                this.fileList = [];
                this.importScanningFileVis = false;
                this.selectedRows = [];
                this.uploadFileFormKeys= [];
            },
            uploadFile(file) {
                // 获取文件参数
                this.fileList = [...this.fileList, file];
                this.uploadFileFormList = this.fileList.map(file => ({ key: file.uid, fileName: file.name, size: file.size, type: file.type}));
                return false;
            },
            clearFileList(){
                // this.fileList = [];
                // this.SubmapTolistLeft = [];
                // this.uploadFileFormList = []
            },
            uploadFileDel() {
                // 删除
                this.fileList = this.fileList.filter(item => !this.selectedRows.some(itemRows => itemRows.fileName === item.name));
                this.uploadFileFormList = this.uploadFileFormList.filter(item => !this.selectedRows.includes(item));
            },
            
        }
    }
</script>

<style>
.divider {
    width: 100%;
    height: 2px;
    background-color: rgb(232, 232, 232);
    border: none;
    margin: 0px;
    margin-top: 3px;
    margin-bottom: 3px;
}
.uploadButton {
    transform: scale(0.8);
}
.buttonLine {
    height: 25px;
}
.button {
    align-items: flex-start;
    margin-right: 8px;
}
.fonterButton {
    margin-right: 20px;
}
</style>